import { intlService } from '~/i18n/IntlService';

export const getLabelsByTextSearchType = () => {
  const intl = intlService.getIntl();
  return {
    filename_content: intl.formatMessage({
      id: 'EviFields.labelsByTextSearchType.filenameContent',
      defaultMessage: 'Filename and Content',
      description: 'Label for filename and content text search type',
    }),
    filename: intl.formatMessage({
      id: 'EviFields.labelsByTextSearchType.filename',
      defaultMessage: 'Filename',
      description: 'Label for filename text search type',
    }),
    content: intl.formatMessage({
      id: 'EviFields.labelsByTextSearchType.content',
      defaultMessage: 'Content',
      description: 'Label for content text search type',
    }),
  };
};
